/**
 * Asks for the next question to be planned without the earlier answers.
 *
 * Offered only once the analyst has shown it is following the conversation,
 * because before then there is nothing to set aside. A toggle rather than an
 * action: it applies to the next message the user sends, whatever that is.
 */
import { CornerDownRight } from "lucide-react";

interface Props {
  active: boolean;
  disabled?: boolean;
  onToggle: () => void;
}

export default function NewTopicButton({ active, disabled = false, onToggle }: Props) {
  return (
    <button
      type="button"
      className="new-topic-button"
      aria-pressed={active}
      disabled={disabled}
      onClick={onToggle}
      title={
        active
          ? "Your next question starts a new topic. Click to keep following the conversation."
          : "Plan your next question on its own, without the earlier answers."
      }
    >
      <CornerDownRight size={14} aria-hidden="true" />
      New topic
    </button>
  );
}
